<template>
  <section class="add-fisa-modal history-modal"
           @mousedown="_clickModal">

    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submit)">

        <!-- DATEPICKER -->
        <validation-provider rules="required"
                             v-slot="{ errors }">
          <div class="relative">
            <i class="absolute left0 top0 flex-center">
              <svg width="20px" height="21px" viewBox="0 0 20 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <path d="M18.75,2.125 L13.75,2.125 L13.75,0.875 C13.75,0.70572832 13.6881517,0.55924541 13.5644531,0.435546875 C13.4407546,0.31184834 13.2942717,0.25 13.125,0.25 C12.9557283,0.25 12.8092454,0.31184834 12.6855469,0.435546875 C12.5618483,0.55924541 12.5,0.70572832 12.5,0.875 L12.5,2.125 L7.5,2.125 L7.5,0.875 C7.5,0.70572832 7.43815166,0.55924541 7.31445312,0.435546875 C7.19075459,0.31184834 7.04427168,0.25 6.875,0.25 C6.70572832,0.25 6.55924541,0.31184834 6.43554688,0.435546875 C6.31184834,0.55924541 6.25,0.70572832 6.25,0.875 L6.25,2.125 L1.25,2.125 C0.898435742,2.125 0.602214746,2.2454415 0.361328125,2.48632812 C0.120441504,2.72721475 0,3.02343574 0,3.375 L0,19 C0,19.3385434 0.120441504,19.6315092 0.361328125,19.8789062 C0.602214746,20.1263033 0.898435742,20.25 1.25,20.25 L18.75,20.25 C19.1015643,20.25 19.3977853,20.1263033 19.6386719,19.8789062 C19.8795585,19.6315092 20,19.3385434 20,19 L20,3.375 C20,3.02343574 19.8795585,2.72721475 19.6386719,2.48632812 C19.3977853,2.2454415 19.1015643,2.125 18.75,2.125 Z M18.75,19 L1.25,19 L1.25,3.375 L6.25,3.375 L6.25,4 C6.25,4.16927168 6.31184834,4.31575459 6.43554688,4.43945312 C6.55924541,4.56315166 6.70572832,4.625 6.875,4.625 C7.04427168,4.625 7.19075459,4.56315166 7.31445312,4.43945312 C7.43815166,4.31575459 7.5,4.16927168 7.5,4 L7.5,3.375 L12.5,3.375 L12.5,4 C12.5,4.16927168 12.5618483,4.31575459 12.6855469,4.43945312 C12.8092454,4.56315166 12.9557283,4.625 13.125,4.625 C13.2942717,4.625 13.4407546,4.56315166 13.5644531,4.43945312 C13.6881517,4.31575459 13.75,4.16927168 13.75,4 L13.75,3.375 L18.75,3.375 L18.75,19 Z M14.375,10.25 L15.625,10.25 C15.7942717,10.25 15.9407546,10.1881517 16.0644531,10.0644531 C16.1881517,9.94075459 16.25,9.79427168 16.25,9.625 L16.25,8.375 C16.25,8.20572832 16.1881517,8.05924541 16.0644531,7.93554688 C15.9407546,7.81184834 15.7942717,7.75 15.625,7.75 L14.375,7.75 C14.2057283,7.75 14.0592454,7.81184834 13.9355469,7.93554688 C13.8118483,8.05924541 13.75,8.20572832 13.75,8.375 L13.75,9.625 C13.75,9.79427168 13.8118483,9.94075459 13.9355469,10.0644531 C14.0592454,10.1881517 14.2057283,10.25 14.375,10.25 Z M14.375,15.25 L15.625,15.25 C15.7942717,15.25 15.9407546,15.1881517 16.0644531,15.0644531 C16.1881517,14.9407546 16.25,14.7942717 16.25,14.625 L16.25,13.375 C16.25,13.2057283 16.1881517,13.0592454 16.0644531,12.9355469 C15.9407546,12.8118483 15.7942717,12.75 15.625,12.75 L14.375,12.75 C14.2057283,12.75 14.0592454,12.8118483 13.9355469,12.9355469 C13.8118483,13.0592454 13.75,13.2057283 13.75,13.375 L13.75,14.625 C13.75,14.7942717 13.8118483,14.9407546 13.9355469,15.0644531 C14.0592454,15.1881517 14.2057283,15.25 14.375,15.25 Z M10.625,12.75 L9.375,12.75 C9.20572832,12.75 9.05924541,12.8118483 8.93554688,12.9355469 C8.81184834,13.0592454 8.75,13.2057283 8.75,13.375 L8.75,14.625 C8.75,14.7942717 8.81184834,14.9407546 8.93554688,15.0644531 C9.05924541,15.1881517 9.20572832,15.25 9.375,15.25 L10.625,15.25 C10.7942717,15.25 10.9407546,15.1881517 11.0644531,15.0644531 C11.1881517,14.9407546 11.25,14.7942717 11.25,14.625 L11.25,13.375 C11.25,13.2057283 11.1881517,13.0592454 11.0644531,12.9355469 C10.9407546,12.8118483 10.7942717,12.75 10.625,12.75 Z M10.625,7.75 L9.375,7.75 C9.20572832,7.75 9.05924541,7.81184834 8.93554688,7.93554688 C8.81184834,8.05924541 8.75,8.20572832 8.75,8.375 L8.75,9.625 C8.75,9.79427168 8.81184834,9.94075459 8.93554688,10.0644531 C9.05924541,10.1881517 9.20572832,10.25 9.375,10.25 L10.625,10.25 C10.7942717,10.25 10.9407546,10.1881517 11.0644531,10.0644531 C11.1881517,9.94075459 11.25,9.79427168 11.25,9.625 L11.25,8.375 C11.25,8.20572832 11.1881517,8.05924541 11.0644531,7.93554688 C10.9407546,7.81184834 10.7942717,7.75 10.625,7.75 Z M5.625,7.75 L4.375,7.75 C4.20572832,7.75 4.05924541,7.81184834 3.93554688,7.93554688 C3.81184834,8.05924541 3.75,8.20572832 3.75,8.375 L3.75,9.625 C3.75,9.79427168 3.81184834,9.94075459 3.93554688,10.0644531 C4.05924541,10.1881517 4.20572832,10.25 4.375,10.25 L5.625,10.25 C5.79427168,10.25 5.94075459,10.1881517 6.06445312,10.0644531 C6.18815166,9.94075459 6.25,9.79427168 6.25,9.625 L6.25,8.375 C6.25,8.20572832 6.18815166,8.05924541 6.06445312,7.93554688 C5.94075459,7.81184834 5.79427168,7.75 5.625,7.75 Z M5.625,12.75 C5.79427168,12.75 5.94075459,12.8118483 6.06445312,12.9355469 C6.18815166,13.0592454 6.25,13.2057283 6.25,13.375 L6.25,14.625 C6.25,14.7942717 6.18815166,14.9407546 6.06445312,15.0644531 C5.94075459,15.1881517 5.79427168,15.25 5.625,15.25 L4.375,15.25 C4.20572832,15.25 4.05924541,15.1881517 3.93554688,15.0644531 C3.81184834,14.9407546 3.75,14.7942717 3.75,14.625 L3.75,13.375 C3.75,13.2057283 3.81184834,13.0592454 3.93554688,12.9355469 C4.05924541,12.8118483 4.20572832,12.75 4.375,12.75 L5.625,12.75 Z" id="" fill="#FFFFFF" fill-rule="nonzero"></path>
                </g>
              </svg>
            </i>
            <datepicker v-model="data.createdAt"
                        :class="{'invalid-input': errors[0]}"
                        :monday-first="true"
                        :language="$data.ro"
                        :format="_customFormatter"
                        :disabled-dates="$data.disabledDates"
                        placeholder="data"
                        name="uniquename" />
          </div>
        </validation-provider>

        <validation-provider rules="required"
                             v-slot="{ errors }">
          <input class="mtop12px mbott20px"
                 :class="{'invalid-input': errors[0]}"
                 type="text"
                 v-model="data.denumire"
                 placeholder="denumire fișă">
        </validation-provider>

        <div class="actions flex flex-between">
          <div class="mauto">
            <upload-img-btn label="fișă"
                            :required="true"
                            :formats="formats"
                            :img="data.pics[0]"
                            @select-img="_selectImg" />
          </div>
        </div>

        <div class="flex flex-between">
          <delete-tratament-btn @delete-tratament="_deleteTratament"
                                @set-delete-mode="_checkDelete" />

          <button class="submit flex-center m-left-auto submit-active">
            <i v-html="svg.save"></i>
          </button>
        </div>

      </form>
    </ValidationObserver>

  </section>
</template>

<script>
  import { mapState } from 'vuex'
  import { historyModal } from '../mixins/history-modal'
  export default {
    name: 'add-importa-fisa-modal',
    mixins: [historyModal],
    data () {
      return {
        formats: ['.pdf']
      }
    },
    computed: {
      ...mapState({
        data: 'modalData',
        isUpdateModal: 'isUpdateModal',
        svg: 'svg'
      })
    },
    methods: {
      submit () {
        const obj = {
          id: this.$router.currentRoute.params.id
        }
        !this.isDelete && this.$store.dispatch(this.isUpdateModal ? 'update_history' : 'save_history', obj)
      }
    }
  }
</script>

<style lang="less">
  .add-document-modal {
  }
</style>
